import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { Dialog } from "./ui/dialog";
import AppInstallDialogContent from "./AppIntallDialogContent";
import { useTranslation } from "@/hooks/useTranslation";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";
import { PageType } from "./PageType";
import { useLocaleTranslation } from "@/hooks/useLocaleTranslation";

export default function AppInstallDialog({ pageType }: { pageType: PageType }) {
  const [installAppOpen, setInstallAppOpen] = useState(false);
  const isStandalone = useStandaloneMode();
  const localeT = useLocaleTranslation();
  const settingsT = useTranslation();
  const t = pageType === PageType.SIGN_IN ? localeT : settingsT;

  useEffect(() => {
    const hasDismissedApplied = sessionStorage.getItem(
      "dismissedInstallApplied",
    );
    const hasDismissedExplore = sessionStorage.getItem(
      "dismissedInstallExplore",
    );

    if (isMobile && !isStandalone) {
      if (pageType === PageType.EXPLORE && !hasDismissedExplore) {
        setInstallAppOpen(true);
        return;
      }

      if (pageType === PageType.SIGN_IN) {
        setInstallAppOpen(true);
        return;
      }

      if (pageType === PageType.APPLIED && !hasDismissedApplied) {
        // Add delay only for the Applied page
        const timer = setTimeout(() => {
          setInstallAppOpen(true);
        }, 2000); // 2 second delay

        // Cleanup timer on unmount or when dependencies change
        return () => clearTimeout(timer);
      }
    }
  }, [pageType]); // Added pageType as dependency since we're using it in the effect

  const handleDismissInstallApp = () => {
    setInstallAppOpen(false);
    if (pageType === PageType.APPLIED) {
      sessionStorage.setItem("dismissedInstallApplied", "true");
    } else if (pageType === PageType.EXPLORE) {
      sessionStorage.setItem("dismissedInstallExplore", "true");
    }
  };

  if (!installAppOpen) return null;

  return (
    <Dialog open={installAppOpen} onOpenChange={handleDismissInstallApp}>
      <AppInstallDialogContent t={t} />
    </Dialog>
  );
}
